/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/chevron-up
 */
import { default as DefaultIcon } from '~icons/lucide/chevron-up';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ChevronUpIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
